import React from 'react';

export default function Maintenance() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '0 16px', background: '#0b1220', color: '#e5e7eb',
      fontFamily: 'system-ui, -apple-system, Segoe UI, sans-serif',
    }}>
      <h1 style={{ fontSize: '1.75rem', margin: '0 0 12px' }}>Under maintenance</h1>
      <p style={{ fontSize: '1.05rem', maxWidth: 480, margin: 0, color: '#9ca3af' }}>
        The website is currently undergoing changes and will be back soon.
      </p>
    </div>
  );
}
